import Relation from './relation.vue'

let Plugin = {}, vueInstance;

Plugin.install = function (Vue, opt) {
    /**
     * 
     * @param {string} relation 关系文本
     * @param {Object} opts 类名及vant.ShareSheet相关属性
     * opts {
     *    className: ['class-name1', 'class-name1'] // 类名
     *    ... // 其它vant.ShareSheet相关属性，https://youzan.github.io/vant/#/zh-CN/share-sheet
     * }
     * @return Promise
     */
    opt.root.relation = function (relation, opts = {}) {
        if (!vueInstance) {
            let el = document.createElement('div')
            document.querySelector('body').appendChild(el)

            let vueClass = Vue.extend(Relation);
        
            vueInstance = new vueClass({
                el: el,
                router: opt.router
            });
        }
        // 设置默认标题
        // !opts.title && (opts.title = '您和他的关系是');
        !opts.title && (opts.title = '联系人是他的');

        vueInstance.wrapshow = true;
        return vueInstance.showPicker(relation, opts);
    }
}


export default Plugin;




